module.exports = function getResource(label) {
    let resources = { sorrySomethingWrong: 'Nous sommes désolés, une erreur s’est produite. Veuillez essayer de nouveau.' };
    return resources[label];
};
